import {
  SPACING,
  JoonUIColor,
  FlexBox,
  Typography,
  SessionBillingPeriod,
} from "@joonapp/web-shared"

import SessionSlot from "./SessionSlot"
import { formatDate } from "../../../util/dates"

const SessionBillingPeriodGroup = ({
  period,
  isCurrentCycle,
}: {
  period: SessionBillingPeriod
  isCurrentCycle: boolean
}) => {
  const bookingsMinusMakeups = period.bookings?.filter(
    (booking) => !booking.missed_session_id
  )
  const numSlots = Math.max(period.max_bookings, bookingsMinusMakeups?.length)

  return (
    <FlexBox direction="column" gap={SPACING.space2}>
      <Typography variant="bodySmall" color={JoonUIColor.text.secondary}>
        {isCurrentCycle ? "CURRENT CYCLE" : "UPCOMING CYCLE"} (
        {formatDate(new Date(period.start_datetime), "MMM D")} -{" "}
        {formatDate(new Date(period.end_datetime), "MMM D")})
      </Typography>
      <FlexBox direction="row" gap={SPACING.space2}>
        {new Array(numSlots).fill(0).map((_, i) => (
          <SessionSlot
            session={bookingsMinusMakeups?.[i]}
            key={i}
            billingPeriod={period}
          />
        ))}
      </FlexBox>
    </FlexBox>
  )
}

export default SessionBillingPeriodGroup
